import Icon from '@/components/ui/AppIcon';

interface EventType {
  id: string;
  name: string;
  icon: string;
  description: string;
  popular: boolean;
}

interface EventTypeSelectorProps {
  selectedType: string;
  onSelect: (typeId: string) => void;
}

const eventTypes: EventType[] = [
  {
    id: 'wedding',
    name: 'Hochzeit',
    icon: 'HeartIcon',
    description: 'Unvergessliche Momente mit authentischer Pizza',
    popular: true,
  },
  {
    id: 'corporate',
    name: 'Firmenveranstaltung',
    icon: 'BuildingOfficeIcon',
    description: 'Beeindrucken Sie Ihre Gäste und Mitarbeiter',
    popular: true,
  },
  {
    id: 'birthday',
    name: 'Geburtstag',
    icon: 'CakeIcon',
    description: 'Feiern Sie mit italienischem Flair',
    popular: false,
  },
  {
    id: 'private',
    name: 'Private Feier',
    icon: 'UserGroupIcon',
    description: 'Perfekt für Familientreffen und Freunde',
    popular: false,
  },
  {
    id: 'other',
    name: 'Festival / Markt / Sonstiges',
    icon: 'SparklesIcon',
    description: 'Großveranstaltungen und besondere Anlässe',
    popular: false,
  },
];

export default function EventTypeSelector({ selectedType, onSelect }: EventTypeSelectorProps) {
  return (
    <div data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:56:4" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="56" data-component-file="EventTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-4%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {eventTypes.map((type) => (
        <button data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:58:8" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="58" data-component-file="EventTypeSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={type.id}
          onClick={() => onSelect(type.id)}
          className={`relative p-6 rounded-lg border-2 transition-all duration-fast text-left ${
            selectedType === type.id
              ? 'border-primary bg-primary/5 shadow-warm'
              : 'border-border hover:border-primary/50 hover:shadow-sm'
          }`}
        >
          {type.popular && (
            <span data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:68:12" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="68" data-component-file="EventTypeSelector.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20top-2%20right-2%20bg-conversion%20text-conversion-foreground%20text-xs%20font-body%20font-semibold%20px-2%20py-1%20rounded%22%2C%22textContent%22%3A%22Beliebt%22%7D" className="absolute top-2 right-2 bg-conversion text-conversion-foreground text-xs font-body font-semibold px-2 py-1 rounded">
              Beliebt
            </span>
          )}
          <div data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:72:10" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="72" data-component-file="EventTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20space-x-4%22%7D" className="flex items-start space-x-4">
            <div data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:73:12" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="73" data-component-file="EventTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`w-12 h-12 rounded-full flex items-center justify-center transition-colors duration-fast ${
                selectedType === type.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              <Icon data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:80:14" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="80" data-component-file="EventTypeSelector.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={type.icon as any} size={24} />
            </div>
            <div data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:82:12" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="82" data-component-file="EventTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">
              <h3 data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:83:14" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="83" data-component-file="EventTypeSelector.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20text-lg%20font-bold%20text-foreground%20mb-1%22%7D" className="font-headline text-lg font-bold text-foreground mb-1">
                {type.name}
              </h3>
              <p data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:86:14" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="86" data-component-file="EventTypeSelector.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%7D" className="text-sm text-muted-foreground">{type.description}</p>
            </div>
          </div>
          {selectedType === type.id && (
            <div data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:90:12" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="90" data-component-file="EventTypeSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-2%20left-2%20w-6%20h-6%20bg-primary%20rounded-full%20flex%20items-center%20justify-center%22%7D" className="absolute top-2 left-2 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
              <Icon data-component-id="src/app/book-your-event/components/EventTypeSelector.tsx:91:14" data-component-path="src/app/book-your-event/components/EventTypeSelector.tsx" data-component-line="91" data-component-file="EventTypeSelector.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CheckIcon%22%2C%22className%22%3A%22text-primary-foreground%22%7D" name="CheckIcon" size={16} className="text-primary-foreground" />
            </div>
          )}
        </button>
      ))}
    </div>
  );
}